var React = require('react');

function Hint (props) {
    return React.createElement("svg",props,[React.createElement("path",{"stroke":"#ffdb00","strokeMiterlimit":"22.93","d":"M24.5 1c2.65 0 3.16 3.06 5.3 3.63 2.13.57 4.15-1.8 6.45-.48s1.21 4.22 2.77 5.8c1.56 1.56 4.5.5 5.83 2.8s-1.06 4.26-.5 6.4c.58 2.14 3.65 2.7 3.65 5.35 0 2.65-3.06 3.16-3.63 5.3-.57 2.13 1.8 4.15.48 6.45s-4.23 1.21-5.79 2.77c-1.57 1.56-.51 4.5-2.81 5.83s-4.27-1.06-6.4-.5c-2.14.58-2.7 3.65-5.35 3.65-2.65 0-3.16-3.06-5.3-3.63-2.13-.57-4.15 1.8-6.45.48s-1.21-4.23-2.77-5.79c-1.56-1.57-4.5-.51-5.83-2.81s1.06-4.27.5-6.4C4.06 27.7 1 27.15 1 24.5c0-2.65 3.06-3.16 3.63-5.3.57-2.13-1.8-4.15-.48-6.45s4.22-1.21 5.8-2.77c1.56-1.56.5-4.5 2.8-5.83s4.26 1.06 6.4.5C21.3 4.06 21.85 1 24.5 1z","clipRule":"evenodd","key":0}),React.createElement("path",{"stroke":"#ffdb00","strokeLinecap":"round","strokeMiterlimit":"22.93","d":"M16 24.89L22.71 31 33 18","key":1})]);
}

Hint.defaultProps = {"fill":"none","viewBox":"0 0 49 49"};

module.exports = Hint;

Hint.default = Hint;
